export default __webpack_public_path__ + "static/media/rj_cover.6f351ca1.jpg";